import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ba6766d8&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=ba6766d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba6766d8",
  null
  
)

export default component.exports